/**
 * Development logging utility for PostHog
 * Logs debug/warn/error messages only in development mode
 */

import { logger } from '@/lib/logger';

/**
 * Log a debug, warn, or error message only in development mode
 * @param level - Log level ('debug', 'warn', or 'error')
 * @param message - Log message
 * @param context - Optional context object
 * @param error - Optional error instance
 */
export function devLog(
  level: 'debug' | 'warn' | 'error',
  message: string,
  context?: Record<string, unknown>,
  error?: Error
): void {
  if (process.env.NODE_ENV === 'development') {
    if (error) {
      logger[level](message, context, error);
    } else {
      logger[level](message, context);
    }
  }
}
